import { axiosRequest, METHOD } from '@/api/default.js';
import constants from '@/constants';

export async function generateCaptcha(lifetimeSeconds = 300) {
    const response = await axiosRequest({
        url: constants.URL.CAPTCHA_GENERATE,
        method: METHOD.POST,
        requestName: 'GENERATE CAPTCHA',
        data: {
            lifetime_seconds: lifetimeSeconds,
        },
        isLoader: false,
        isShowPopup: false,
    });

    if (response === null) {
        return {
            success: false,
            error: 'Failed to generate CAPTCHA',
        };
    }

    return {
        success: true,
        data: response,
    };
}
